import * as React from 'react';
import { useRouteScenario } from 'src/hooks/useRouteScenario';
import { OrderScenario } from 'components/order/model/Order';
import { ViewBasketPage } from './view-basket';
import { useLocalHistory } from 'lib/useLocalHistory';
import { ROUTES } from './routes';

export const Basket: React.FC = () => {
    const [scenario] = useRouteScenario();
    const { replace } = useLocalHistory();
    React.useEffect(() => {
        if (scenario === OrderScenario.TABLE) {
            replace(ROUTES.QUICKPAY.BASKET);
        }
    }, [replace, scenario]);
    return <ViewBasketPage />;
};
